<template>
    <section class="font-poppins">
        <div class="flex justify-between">
            <div class="w-2/3 md:w-full p-2">
                <div class="flex justify-between mt-8 ">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">5/5</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 flex justify-content-center">
                            <h2 class="text-blue-600 font-semibold- md:text-lg" style="color:rgb(18,84,179)">Sign Up as a DSP</h2>
                        </div>
                        <div class="w-4/5 md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Company Details</p>
                                <p class="mt-1 font-medium">upload only pdf, jpg, jpeg or png</p>
                            </div>
                            <div class="mt-5">
                                <form @submit.prevent="submitDetails">
                                    <div>
                                        <label for="company-name" class="font-bold">Company Name</label>
                                        <input class="p-2 pl-2 w-full rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179) " type="text" name="companyName" id="companyName" placeholder="Type Here" v-model="companyName"> <br>
                                        <p v-if="companyNameValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>

                                    </div>

                                    <div class="mt-4">
                                        <p class="font-bold">Company Description</p>
                                        <textarea class="border w-full bg-gray-100 p-2 rounded-lg" style="border:1px solid rgb(18,84,179)" name="description" id="description" cols="0" rows="5" v-model="companyDetails">Type Here</textarea>
                                        <p v-if="companyDetailsValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                                    </div>

                                    <div class="mt-4">
                                        <label for="company-name" class="font-bold">Office Address</label>
                                        <input class="p-2 pl-2 w-full rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179) " type="text" name="officeLocation" id="officeLocation" placeholder="Type Here" v-model="officeLocation"> <br>
                                        <p v-if="officeLocationValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>

                                    <div class="mt-4 hidden">
                                        <div>
                                            <label class="font-bold" for="passort">CAC Certificate</label>
                                            <input style="display:none;  border:1px solid rgb(18,84,179) " type="file" name="cacRegNo" id="cacRegNo" @change="onCacReg" ref="cacRegUpload">
                                            <p style=" border:1px solid rgb(18,84,179) " class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.cacRegUpload.click()">--upload file-- {{this.cacRegName}} </p>

                                            <p v-if="cacRegValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="cacFileError" class=" text-xs text-red-500">{{cacFileError}}</p>
                                        </div>

                                    </div>

                                    <div class="mt-4 hidden">
                                        <div>
                                            <label class="font-bold" for="passort">Hackney Permit</label>
                                            <input style="display:none; " type="file" name="hackneyPermit" id="hackneyPermit" @change="onHackney" ref="hackneyPermitUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" style=" border:1px solid rgb(18,84,179) " @click="$refs.hackneyPermitUpload.click()">--upload file-- {{this.hackneyName}} </p>
                                            <p v-if="hackneyValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="hackneyFileError" class=" text-xs text-red-500">{{hackneyFileError}}</p>
                                        </div>

                                    </div>
                                   
                                   <div>
                                       <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a @click="showPolicy" class="text-blue-500 cursor-pointer" >Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer">Privacy policy</a>
                                            </p>
                                        </div>
                                        <p v-if="checkValidity === 'invalid'" class=" text-xs text-red-500">Agree to T&C to proceed.</p>
                                   </div>
                                    <p class="text-red-500 text-sm">{{error}}</p>
                                    <div class="mt-10 flex">
                                        <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>     
                    </div>   
                </div>
            </div>
            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>
        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import TermsPolicyModal from '../TermsPolicyModal.vue';
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components:{TermsPolicyModal},

    data() {
        return {
            companyName:'',
            companyDetails: '',
            officeLocation: '',
            cacReg: null,
            cacRegName: null,
            hackney: null,
            hackneyName: null,
            checkbox: '',
            isLoading: false,

            companyNameValidity: '',
            companyDetailsValidity: '',
            officeLocationValidity: '',
            cacRegValidity: '',
            hackneyValidity: '',
            checkValidity: '',
            termsPolicy: false,
            error: "",
            cacFileError: "",
            hackneyFileError: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        showPolicy() {
            this.termsPolicy = true;
        },
         closeModal() {
            this.termsPolicy = false;
        },
        onCacReg(event) {
            this.cacReg = event.target.files[0]
            this.cacRegName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.cacFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.cacFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.cacFileError = "";
                }, 1000);
            }
        },
        onHackney(event) {
            this.hackney = event.target.files[0]
            this.hackneyName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.hackneyFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.hackneyFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.hackneyFileError = "";
                }, 1000);
            }
        },

        submitDetails() {
            this.networkError();
            if(!this.companyName) {
                this.companyNameValidity = 'invalid';
                 setTimeout(() => {
                    this.companyNameValidity = "";
                }, 3000);
            } else if (!this.companyDetails) {
                this.companyDetailsValidity = 'invalid'
                 setTimeout(() => {
                    this.companyDetailsValidity = "";
                }, 3000);
            } else if (!this.officeLocation) {
                this.officeLocationValidity = 'invalid';
                 setTimeout(() => {
                    this.officeLocationValidity = "";
                }, 3000);
            }else if (!this.checkbox) {
                this.checkValidity = 'invalid'
                 setTimeout(() => {
                    this.checkValidity = "";
                }, 3000);
            } else {
                this.isLoading = true
                let data = new FormData();
                data.append('email', localStorage.getItem("dsoEmail"));
                data.append('companyName', this.companyName); 
                data.append('companyDescription', this.companyDetails); 
                data.append('officeLocation', this.officeLocation); 
                data.append('registration', "completed"); 
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/dsos/update`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data:data
                })
                .then((response) => {
                    response.json
                    this.$store.commit("setAuthentication", true)  ;      
                    this.isLoading = false;
                    localStorage.removeItem("dsoEmail");
                    localStorage.removeItem("dsoPhone");
                    this.$router.push('/success');
                })

                .catch((error) => {
                    this.error = error.response.data.message;
                     setTimeout(() => {
                    this.error = "";
                }, 3000);
                    this.isLoading = false
                    error.json;
                });
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
